import styled from '@emotion/styled'
import { TextButton } from 'view/components/buttons'
import { Direction } from 'api'
import * as constants from 'view/styles/constants'

export const Card = styled.div<{ dead?: boolean; inTicket?: boolean }>`
  display: flex;
  height: 80px;
  width: 100%;
  overflow: hidden;
  background-color: ${constants.CORE_PRIMARY};
  border: ${props => (props.inTicket ? '0px' : '1px')} solid ${constants.CARD_BORDER};
  border-left: none;

  & * {
    color: ${props => (props.dead ? `${constants.CORE_PRIMARY_5} !important` : '')};
  }
`

export const StatusStrip = styled.div<{ statusColor: string }>`
  flex: 0 0 4px;
  background-color: ${props => props.statusColor};
`

export const CardContent = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const Status = styled.div`
  font-size: 14px;
  color: ${constants.CORE_PRIMARY_6};
  text-transform: uppercase;
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Bold};
`

export const CardHeader = styled.div<{ statusColor: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 27px;
  min-width: 0;
  width: 100%;
  padding: 4px 6px;
  border-bottom: 1px solid ${constants.CORE_PRIMARY_1};
  background-color: ${props => props.statusColor};

  & div {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    color: ${props => (props.statusColor === 'initial' ? 'initial' : 'white')};
  }

  & div:not(${Status}) {
    margin-left: 3px;
  }

  & ${Status} {
    flex: 1 0 auto;
    min-width: 0;

    span {
      font-family: inherit;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    svg {
      height: 20px;
      flex: 0 0 20px;
      margin-right: 3px;
    }
  }
`

export const Substatus = styled.div<{ grey?: boolean }>`
  display: flex;
  align-items: center;

  & span {
    display: flex;
    align-items: center;
    color: ${props => (props.grey ? constants.CORE_PRIMARY_5 : 'inherit')};
    font-weight: ${constants.FontWeight.Bold};
  }

  & span svg {
    width: 12px;
    height: 12px;
    color: inherit;
  }

  & span:not(:last-of-type):not(:empty) {
    margin-right: 5px;
  }
`

export const Details = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  padding: 8px 10px 10px 10px;
`

export const DetailColumn = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  &:not(:only-of-type):last-of-type {
    justify-content: center;
    flex: 0 0 82px;
  }
`

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > span {
    font-size: 12px;
    color: ${constants.CORE_PRIMARY_6};
  }

  & > span:not(:first-of-type) {
    margin-left: 5px;
  }
`

export const Headline = styled.span`
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const KeyInfo = styled(Headline)`
  font-weight: ${constants.FontWeight.Bold};
`

export const DirectionLabel = styled.span<{ direction: Direction | null }>`
  font-weight: ${constants.FontWeight.SemiBold};
  text-transform: uppercase;
  color: ${props => (props.direction === Direction.BUY ? constants.DIRECTION_BUY : constants.DIRECTION_SELL)};
  margin-right: 5px;
`

export const TicketButton = styled(TextButton)`
  font-size: 11px;
  color: white !important;
  min-width: 0;
`
